import { useQuery } from "@tanstack/react-query";
import type { OrgEntitlements } from "@backstory/protocol";
import { request } from "../../api";

export function entitlementsKey(orgId: string) {
  return ["entitlements", orgId] as const;
}

export function useOrgEntitlements(orgId?: string) {
  return useQuery({
    queryKey: entitlementsKey(orgId ?? "none"),
    queryFn: () => request<OrgEntitlements>(`/v1/orgs/${encodeURIComponent(orgId!)}/entitlements`),
    enabled: !!orgId,
    staleTime: 30_000,
    retry: 0,
  });
}

/** True when the loaded answer includes the feature. While it is still loading, the menu stays as it was. */
export function allowsFeature(e: OrgEntitlements | undefined, feature: string | undefined): boolean {
  if (!feature || !e) return true;
  return e.features.includes("everything") || e.features.includes(feature);
}
